import { Button } from "@/components/ui/button";

const CALENDLY_URL = "https://calendly.com/meneora/appel-clarte-de-15-minutes";

const Hero = () => {
  return (
    <section id="home" className="min-h-[56vh] flex items-center relative overflow-hidden pt-20">
      <div className="absolute inset-0 z-0">
        <img 
          src="/lovable-uploads/7a03015c-8263-4d46-94a2-1647d315ab39.png" 
          alt="Et si ce flou que tu ressens était le début de quelque chose" 
          className="w-full h-full object-cover opacity-20"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background/50 to-background"></div>
      </div>
      
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 py-12">
        <div className="text-center">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-primary mb-6 animate-fade-in leading-tight">
            Et si ce flou que tu ressens était le début de quelque chose ?
          </h1>
          <div className="text-lg md:text-xl text-foreground/80 mb-8 space-y-3 animate-fade-in animate-delay-200 max-w-2xl mx-auto">
            <p>Tu avances… mais sans vraiment savoir où tu vas.</p>
            <p>Tu ressens que quelque chose doit changer, sans réussir à mettre des mots dessus.</p>
            <p>Fatigue, perte de sens, trop-plein… ou juste cette impression d'être à côté.</p>
            <p>Tu n'as pas besoin d'avoir tout compris.</p>
            <p className="font-medium">Juste d'un espace pour faire le point.</p>
          </div>
          <a href={CALENDLY_URL} target="_blank" rel="noopener noreferrer">
            <Button size="lg" className="text-lg animate-fade-in animate-delay-300">
              Prendre un temps d'échange
            </Button>
          </a>
        </div>
      </div>
    </section>
  );
};

export default Hero;
